import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SafetyControlSurveyTeamsDataGrid } from "src/components/views/erp/safetyControlSurvey/masterData/SafetyControlSurveyTeamsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/safetyControlSurvey/teams")({
	staticData: { title: i18n.t("safety_control_survey_teams"), legacyViewKey: "safetyControlSurveyTeamsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SafetyControlSurveyTeamsDataGrid />;
}
